// Fill array with numbers between start & end
const fillRange = ({ start, end }) =>
  Array(end - start + 1)
    .fill()
    .map((_, idx) => start + idx)

export default fillRange
